/* WA Routine Stepper — component JS for sections/wa-routine-stepper.liquid.
   Config comes from the section's [data-wa-config] JSON island; no Liquid here. */
  (function () {
    if (customElements.get('wa-routine-stepper')) return;

    class WARoutineStepper extends HTMLElement {
      connectedCallback() {
        if (!this._initialized) {
          const cfgEl = this.querySelector('[data-wa-config]');
          if (!cfgEl) return;
          try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
          const p1v = this.cfg.p1 && this.cfg.p1.variants;
          const p2v = this.cfg.p2 && this.cfg.p2.variants;
          if (!p1v || !p1v.length || !p2v || !p2v.length) return;
          this._initialized = true;
          this.step = 1;
          this.include = { p1: true, p2: true, p3: true };
          this.threshold = parseFloat(this.getAttribute('data-threshold') || '55') * 100;
          this.DISCO = { pink: 'Blue/Purple/Red', peach: 'Green/Grey/Brown' };
          this._annotate();
          this._buildSwatches('p1');
          this._buildSwatches('p2');
        }
        this._wire();
        this.render();
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        this._unwire();
      }

      // Shade matching per the team's Wide Awake mapping sheet (boundaries
      // confirmed by the merch sheet, Sept 8 2026):
      //   0.5N–6N  -> Fair Pink (Blue/Purple/Red) | Fair Peach (Green/Grey/Brown)
      //   7W–12C   -> Light Peachy Pink | Light Peach
      //   15N–16N  -> Medium Peachy Pink | Medium Peach
      //   17W–19W  -> Dark Peachy Pink | Dark Apricot
      //   20C–21N  -> Deep Peachy Pink (Red/Brown)
      //   22W–25N  -> Concealer in 22W (Red/Brown) — the canceling layer is the concealer itself.
      // Ranges are matched by canonical index so stand-in variant titles still work.
      _annotate() {
        var self = this;
        this.cfg.p1.variants.forEach(function (v, i) {
          v.hex = (self.cfg.p1.hexes || [])[i] ? self.cfg.p1.hexes[i].trim() : '#d9a688';
        });
        this.cfg.p2.variants.forEach(function (v, i) {
          v.hex = (self.cfg.p2.hexes || [])[i] ? self.cfg.p2.hexes[i].trim() : '#dda192';
        });
        // canonical neutralizer order: index into p2.variants (title match first, index fallback)
        this.N = {};
        var names = ['Fair Pink','Fair Peach','Light Peachy Pink','Light Peach','Medium Peachy Pink','Medium Peach','Dark Peachy Pink','Dark Apricot','Deep Peachy Pink'];
        names.forEach(function (nm, i) {
          var hit = self.cfg.p2.variants.findIndex(function (v) { return String(v.title).toLowerCase() === nm.toLowerCase(); });
          self.N[nm] = hit > -1 ? hit : Math.min(i, self.cfg.p2.variants.length - 1);
        });
        this.MAP = [
          { from: 0,  to: 6,  opts: [ { p: 'p2', name: 'Fair Pink', disco: 'Blue/Purple/Red' }, { p: 'p2', name: 'Fair Peach', disco: 'Green/Grey/Brown' } ] },
          { from: 7,  to: 12, opts: [ { p: 'p2', name: 'Light Peachy Pink', disco: 'Blue/Purple/Red' }, { p: 'p2', name: 'Light Peach', disco: 'Green/Grey/Brown' } ] },
          { from: 13, to: 14, opts: [ { p: 'p2', name: 'Medium Peachy Pink', disco: 'Blue/Purple/Red' }, { p: 'p2', name: 'Medium Peach', disco: 'Green/Grey/Brown' } ] },
          { from: 15, to: 18, opts: [ { p: 'p2', name: 'Dark Peachy Pink', disco: 'Blue/Purple/Red' }, { p: 'p2', name: 'Dark Apricot', disco: 'Green/Grey/Brown' } ] },
          { from: 19, to: 20, opts: [ { p: 'p2', name: 'Deep Peachy Pink', disco: 'Red/Brown' } ] },
          { from: 21, to: 24, opts: [ { p: 'p1', idx: 21, disco: 'Red/Brown' } ] }
        ];
        // Canonical concealer ladder from the shade-descriptions list. Variants are
        // matched by TITLE (the real product's shade codes) so an admin variant
        // reorder can't shift recommendations; position is only the fallback for
        // stand-in products whose titles aren't codes.
        var norm = function (t) { return String(t).replace(/\s+/g, '').toUpperCase(); };
        this.LADDER = (this.cfg.descs1 || '').split('\n').map(function (l) {
          var cut = l.indexOf(' - '); return norm(cut < 0 ? l : l.slice(0, cut));
        });
        this.vIdxByLadder = this.LADDER.map(function (code, k) {
          var hit = self.cfg.p1.variants.findIndex(function (v) { return norm(v.title) === code; });
          return hit > -1 ? hit : Math.min(k, self.cfg.p1.variants.length - 1);
        });
        this.ladderByVIdx = {};
        this.vIdxByLadder.forEach(function (vi, k) { if (!(vi in self.ladderByVIdx)) self.ladderByVIdx[vi] = k; });

        var ds = this.cfg.defaultShade;
        var idx = this.cfg.p1.variants.findIndex(function (v) { return v.title === ds && v.available; });
        if (idx < 0) idx = this.cfg.p1.variants.findIndex(function (v) { return v.available; });
        this._defIdx = Math.max(0, idx);
        this.sel1 = null;
        this.sel2 = null;
      }

      // Resolve the option rows for the current concealer index.
      _shadeDesc(list, i) {
        if (!list) return null;
        var line = list.split('\n')[i];
        if (!line) return null;
        var cut = line.indexOf(' - ');
        if (cut < 0) return null;
        return { name: line.slice(0, cut).trim(), desc: line.slice(cut + 3).trim() };
      }

      _ladderPos() {
        var k = this.ladderByVIdx[this._i1()];
        return k == null ? this._i1() : k;
      }

      _rows() {
        const self = this;
        const i = this._ladderPos();
        const range = this.MAP.filter(function (r) { return i >= r.from && i <= r.to; })[0] || this.MAP[this.MAP.length - 1];
        return range.opts.map(function (o) {
          if (o.p === 'p1') {
            const pi = self.vIdxByLadder[o.idx] != null ? self.vIdxByLadder[o.idx] : Math.min(o.idx, self.cfg.p1.variants.length - 1);
            const cv = self.cfg.p1.variants[pi];
            if (!cv) return null;
            return { p: 'p1', i: pi, title: cv.title, hex: cv.hex, disco: o.disco, productTitle: self.cfg.p1.title, avail: !!cv.available };
          }
          const vi = self.N[o.name];
          const v = self.cfg.p2.variants[vi];
          if (!v) return null;
          return { p: 'p2', i: vi, title: o.name, hex: v.hex, disco: o.disco, productTitle: self.cfg.p2.title, avail: !!v.available };
        }).filter(function (r) { return r && r.avail; });
      }
      _active2() {
        if (this.sel2 !== null) return this.sel2;
        const r = this._rows()[0];
        if (!r) return null;
        return { p: r.p, i: r.i };
      }
      _sel2Item() {
        const a = this._active2();
        if (!a || !this.cfg[a.p]) return { key: null, variant: null, sel: a };
        return { key: a.p, variant: this.cfg[a.p].variants[a.i] || null, sel: a };
      }

      _buildSwatches(key) {
        var self = this;
        var wrap = this.querySelector('[data-wa-' + key + '-swatches]');
        if (!wrap) return;
        this.cfg[key].variants.forEach(function (v, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'wa-swatch' + (v.available ? '' : ' is-unavailable');
          b.setAttribute('aria-label', v.title); b.title = v.title;
          b.innerHTML = '<i style="background:' + v.hex + '"></i>';
          b.addEventListener('click', function () {
            if (key === 'p1') { self.sel1 = i; self.sel2 = null; }
            else { self.sel2 = { p: 'p2', i: i }; }
            self.render();
          });
          wrap.appendChild(b);
        });
      }

      _wire() {
        if (this._wired) return;
        this._onPrev = () => { this.go(this.step - 1); };
        this._onNext = () => { this.go(this.step + 1); };
        this._onAtc = () => { this._addToCart(); };
        this._onStep = (e) => { this.go(parseInt(e.currentTarget.getAttribute('data-wa-step'), 10)); };
        this._onEdit = (e) => { this.go(parseInt(e.currentTarget.getAttribute('data-wa-edit'), 10)); };
        this._onInc = (e) => {
          const k = e.currentTarget.getAttribute('data-wa-inc');
          this.include[k] = !this.include[k];
          this.render();
        };
        this._prevBtn = this.querySelector('[data-wa-prev]');
        this._nextBtn = this.querySelector('[data-wa-next]');
        this._atcBtn = this.querySelector('[data-wa-atc]');
        this._stepBtns = Array.from(this.querySelectorAll('[data-wa-step]'));
        this._editBtns = Array.from(this.querySelectorAll('[data-wa-edit]'));
        this._incBtns = Array.from(this.querySelectorAll('[data-wa-inc]'));
        if (this._prevBtn) this._prevBtn.addEventListener('click', this._onPrev);
        if (this._nextBtn) this._nextBtn.addEventListener('click', this._onNext);
        if (this._atcBtn) this._atcBtn.addEventListener('click', this._onAtc);
        this._stepBtns.forEach((b) => b.addEventListener('click', this._onStep));
        this._editBtns.forEach((b) => b.addEventListener('click', this._onEdit));
        this._incBtns.forEach((b) => b.addEventListener('click', this._onInc));
        this._wired = true;
      }

      _unwire() {
        if (!this._wired) return;
        if (this._prevBtn) this._prevBtn.removeEventListener('click', this._onPrev);
        if (this._nextBtn) this._nextBtn.removeEventListener('click', this._onNext);
        if (this._atcBtn) this._atcBtn.removeEventListener('click', this._onAtc);
        this._stepBtns.forEach((b) => b.removeEventListener('click', this._onStep));
        this._editBtns.forEach((b) => b.removeEventListener('click', this._onEdit));
        this._incBtns.forEach((b) => b.removeEventListener('click', this._onInc));
        this._wired = false;
      }

      _i1() { return this.sel1 == null ? this._defIdx : this.sel1; }
      _maxStep() { return this.sel1 == null ? 1 : (this.sel2 == null ? 2 : 3); }

      go(n) {
        const dest = Math.min(this._maxStep(), Math.min(3, Math.max(1, n)));
        if (dest > this.step) {
          const v = this.step === 1 ? this.cfg.p1.variants[this.sel1] : this._sel2Item().variant;
          if (!v || !v.available) return;
        }
        this.step = dest;
        this.render();
      }

      render() {
        if (!this.cfg || !this.cfg.p1 || !this.cfg.p1.variants || !this.cfg.p1.variants.length) return;
        var self = this;
        var c = this.cfg.p1.variants[this._i1()];
        if (!c) return;
        var a2 = this.sel2;
        var n = (a2 && this.cfg[a2.p]) ? (this.cfg[a2.p].variants[a2.i] || null) : null;

        this.querySelectorAll('[data-wa-step]').forEach(function (b) {
          var k = parseInt(b.getAttribute('data-wa-step'), 10);
          b.classList.toggle('is-active', k === self.step);
          b.classList.toggle('is-done', k < self.step);
        });
        this.querySelectorAll('[data-wa-panel]').forEach(function (p) {
          p.toggleAttribute('hidden', parseInt(p.getAttribute('data-wa-panel'), 10) !== self.step);
        });

        var p1name = this.querySelector('[data-wa-p1-name]');
        // Show the canonical WA shade code, not the raw variant title — on
        // stand-in products the titles are 1-based ("Shade 11") while the WA
        // ladder starts at 0.5N, which reads as an off-by-one next to the
        // description line. Identical on the real product (titles ARE codes).
        var ladderName = this._shadeDesc(this.cfg.descs1, this._ladderPos());
        if (p1name) p1name.textContent = this.sel1 == null ? '' : (ladderName ? ladderName.name : c.title);
        var w1 = this.querySelectorAll('[data-wa-p1-swatches] .wa-swatch');
        w1.forEach(function (b, i) { b.classList.toggle('is-selected', i === self.sel1); });
        var w2 = this.querySelectorAll('[data-wa-p2-swatches] .wa-swatch');
        w2.forEach(function (b, i) { b.classList.toggle('is-selected', !!(self.sel2 && self.sel2.p === 'p2' && i === self.sel2.i)); });

        // discoloration rows — the team's shade table drives these
        var disco = this.querySelector('[data-wa-disco]');
        if (disco) {
          disco.innerHTML = '';
          var rows = this._rows();
          rows.forEach(function (r) {
            var row = document.createElement('div'); row.className = 'wa-rs__disco';
            var picked = !!(self.sel2 && a2 && a2.p === r.p && a2.i === r.i);
            var label = r.p === 'p1' ? (r.productTitle + ' in ' + r.title) : r.title;
            // Single-match ranges (20C+) don't depend on discoloration — use the
            // live set's "Based on your …" heading instead of "If you have …".
            var q = rows.length === 1
              ? 'Based on your ' + self.cfg.p1.title + ' shade selection'
              : 'If you have ' + r.disco + ' under eyes';
            row.innerHTML =
              '<span class="wa-rs__disco-sw" style="background:' + r.hex + '"></span>' +
              '<span class="wa-rs__disco-info">' +
              '<p class="wa-rs__disco-q">' + q + '</p>' +
              '<p class="wa-rs__disco-rec">Recommended for you — <b>' + label + '</b></p></span>' +
              '<button class="wa-rs__disco-btn' + (picked ? ' is-picked' : '') + '" type="button">' + (picked ? 'Selected' : 'Use this shade') + '</button>';
            row.querySelector('.wa-rs__disco-btn').addEventListener('click', function () {
              self.sel2 = { p: r.p, i: r.i }; self.render();
            });
            disco.appendChild(row);
          });

        }

        // selected-shade lines under the swatches. Copy comes from the static
        // per-shade lists (launch copy, keyed by variant order) with the variant
        // metafield as fallback. Step 2's line hides for the deep-range
        // concealer-as-canceler pick, where the "shade" is a p1 variant.
        // Live-set descriptor format: "Shade 0.5N: is for very pale with …"
        var isFor = function (d) {
          if (!d) return '';
          var t = d.replace(/^is for /i, '').replace(/^for /i, '');
          return 'is for ' + t.charAt(0).toLowerCase() + t.slice(1);
        };
        var d1 = this.sel1 == null ? null : this._shadeDesc(this.cfg.descs1, this._ladderPos());
        var nm1El = this.querySelector('[data-wa-p1-info-name]');
        var ds1El = this.querySelector('[data-wa-p1-desc]');
        if (nm1El) nm1El.textContent = this.sel1 == null ? '' : ('Shade ' + (d1 ? d1.name : c.title));
        if (ds1El) ds1El.textContent = this.sel1 == null ? '' : isFor(d1 ? d1.desc : (c.desc || ''));
        var d2 = a2 && a2.p === 'p2' ? this._shadeDesc(this.cfg.descs2, a2.i) : null;
        var nmEl = this.querySelector('[data-wa-p2-name]');
        var dsEl = this.querySelector('[data-wa-p2-desc]');
        if (nmEl) nmEl.textContent = (this.sel2 && a2 && a2.p === 'p2' && n) ? (d2 ? d2.name : n.title) : '';
        if (dsEl) dsEl.textContent = (this.sel2 && a2 && a2.p === 'p2' && n) ? isFor(d2 ? d2.desc : (n.desc || '')) : '';

        // Deep-range flag — the live set's bottom-of-panel Note treatment
        var noteWrap = this.querySelector('[data-wa-note]');
        if (noteWrap) {
          var deepRows = this._rows();
          var showNote = deepRows.length === 1 && deepRows[0].p === 'p1' && this.cfg.deepNote;
          noteWrap.innerHTML = showNote
            ? '<div class="wa-rs__rec-note">' +
              '<div class="wa-rs__rec-note-body"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M7.50004 0.0625C9.47273 0.0625 11.3646 0.846148 12.7595 2.24105C14.1544 3.63595 14.9381 5.52784 14.9381 7.50053C14.9381 9.47322 14.1544 11.3651 12.7595 12.76C11.3646 14.1549 9.47273 14.9386 7.50004 14.9386C5.52735 14.9386 3.63546 14.1549 2.24056 12.76C0.845659 11.3651 0.0620117 9.47322 0.0620117 7.50053C0.0620117 5.52784 0.845659 3.63595 2.24056 2.24105C3.63546 0.846148 5.52735 0.0625 7.50004 0.0625ZM8.61567 4.62912C9.16817 4.62912 9.61654 4.24556 9.61654 3.67712C9.61654 3.10869 9.16711 2.72513 8.61567 2.72513C8.06317 2.72513 7.61692 3.10869 7.61692 3.67712C7.61692 4.24556 8.06317 4.62912 8.61567 4.62912ZM8.81011 10.6078C8.81011 10.4941 8.84942 10.1987 8.8271 10.0309L7.95373 11.036C7.77311 11.2262 7.54679 11.3579 7.44054 11.3229C7.39234 11.3051 7.35205 11.2708 7.32692 11.226C7.30179 11.1812 7.29348 11.1289 7.30348 11.0785L8.75911 6.48C8.87811 5.89669 8.55086 5.36438 7.85704 5.29638C7.12498 5.29638 6.04761 6.03906 5.39204 6.9815C5.39204 7.09413 5.37079 7.37462 5.39311 7.5425L6.26542 6.53631C6.44604 6.34825 6.65642 6.21544 6.76267 6.25156C6.81502 6.27035 6.85791 6.30891 6.88214 6.35897C6.90638 6.40903 6.91002 6.4666 6.89229 6.51931L5.44942 11.0955C5.28261 11.631 5.59817 12.1559 6.36317 12.2749C7.48942 12.2749 8.15454 11.5503 8.81117 10.6078H8.81011Z" fill="black"></path></svg><strong>Note</strong></div>' +
              '<p>' + this.cfg.deepNote + '</p></div>'
            : '';
        }

        // review
        var sw1 = this.querySelector('[data-wa-rev-p1-sw]'); if (sw1) sw1.style.background = c.hex;
        var t1 = this.querySelector('[data-wa-rev-p1]'); if (t1) t1.textContent = c.title + ' · ' + this._money(c.price);
        var sw2 = this.querySelector('[data-wa-rev-p2-sw]'); if (sw2 && n) sw2.style.background = n.hex;
        var t2 = this.querySelector('[data-wa-rev-p2]');
        if (t2) {
          if (!n) {
            t2.textContent = '';
          } else {
            var prefix = a2 && a2.p === 'p1' ? this.cfg.p1.title + ' in ' : '';
            t2.textContent = prefix + n.title + (this.sel2 === null ? ' (recommended)' : '') + ' · ' + this._money(n.price);
          }
        }

        var total = 0, count = 0;
        var sameP1P2 = !!(n && n.id === c.id);
        var cancelIsConcealer = !!(a2 && a2.p === 'p1');
        var items = { p1: c, p2: n, p3: this.cfg.p3 && this.cfg.p3.variants ? this.cfg.p3.variants[0] : null };
        var p2head = this.querySelector('[data-wa-review="p2"] .wa-rs__review-title');
        if (p2head) {
          var roleEl = p2head.querySelector('em');
          var role = roleEl ? roleEl.textContent : 'Cancel';
          p2head.innerHTML = '<em>' + role + '</em> — ' + (cancelIsConcealer ? this.cfg.p1.title : this.cfg.p2.title);
        }
        ['p1', 'p2', 'p3'].forEach(function (k) {
          var on = self.include[k];
          var btn = self.querySelector('[data-wa-inc="' + k + '"]');
          if (btn) { btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', String(on)); }
          var row = self.querySelector('[data-wa-review="' + k + '"]');
          if (row) {
            row.hidden = k === 'p2' && sameP1P2 && self.include.p1;
            row.classList.toggle('is-off', !on);
          }
          if (k === 'p2' && sameP1P2 && self.include.p1) return;
          if (on && items[k]) { total += items[k].price; count += 1; }
        });

        var atc = this.querySelector('[data-wa-atc]');
        var lbl = this.querySelector('[data-wa-atc-label]');
        var priceEl = this.querySelector('[data-wa-atc-price]');
        var stocked = (!this.include.p1 || !!c.available) &&
          (!this.include.p2 || sameP1P2 || !!(n && n.available)) &&
          (!this.include.p3 || !!(items.p3 && items.p3.available));
        if (this._adding) {
          if (lbl) lbl.textContent = 'ADDING...';
          if (priceEl) priceEl.textContent = '';
          if (atc) atc.disabled = true;
        } else {
          if (lbl) lbl.textContent = count === 3 ? this.cfg.atcLabelFull : count === 0 ? 'Add to bag' : 'Add ' + count + ' to bag';
          if (priceEl) priceEl.textContent = count === 0 ? '' : this._money(total);
          if (atc) atc.disabled = this.step !== 3 || count === 0 || this.sel1 === null || (this.include.p2 && this.sel2 === null) || !stocked;
        }

        var ship = this.querySelector('[data-wa-ship]');
        if (ship) {
          ship.toggleAttribute('hidden', count === 0);
          var shipText = this.querySelector('[data-wa-ship-text]');
          if (shipText) shipText.textContent = total >= this.threshold ? this.cfg.shipText : this.cfg.shipNudge;
        }

        if (this._prevBtn) this._prevBtn.disabled = this.step === 1;
        var stepDone = this.step === 1 ? this.sel1 !== null : this.sel2 !== null;
        var selUnavailable = (this.step === 1 && this.sel1 !== null && !c.available) ||
          (this.step === 2 && this.sel2 !== null && !(n && n.available));
        if (this._nextBtn) this._nextBtn.disabled = this.step === 3 || !stepDone || selUnavailable;
      }

      _money(cents) {
        // Liquid emits variant prices in the market's presentment currency, so
        // format with the shop's active currency rather than a hardcoded "$".
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      _cartRequest(type, body) {
        var self = this;
        return new Promise(function (resolve) {
          window.liquidAjaxCart[type](body, {
            info: { initiator: self },
            lastCallback: resolve
          });
        });
      }

      _addToCart() {
        if (this._adding) return;
        if (!window.liquidAjaxCart || typeof window.liquidAjaxCart.add !== 'function') return;
        const seen = {};
        const items = [];
        const push = (v) => {
          if (!v || !v.id || seen[v.id]) return;
          seen[v.id] = true;
          items.push({ id: v.id, quantity: 1, inventory: v.inventory, available: v.available });
        };
        if (this.include.p1) push(this.cfg.p1.variants[this._i1()]);
        if (this.include.p2) push(this._sel2Item().variant);
        if (this.include.p3 && this.cfg.p3 && this.cfg.p3.variants) push(this.cfg.p3.variants[0]);
        if (!items.length) return;
        var self = this;
        this._adding = true;
        this.render();
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var lines = (cart && cart.items) || [];
            var toAdd = [];
            var updates = {};
            var blocked = false;
            items.forEach(function (item) {
              var inCart = 0;
              var line = null;
              lines.forEach(function (li) {
                if (Number(li.variant_id || li.id) !== Number(item.id)) return;
                inCart += li.quantity || 0;
                if (!line) line = li;
              });
              var next = inCart + item.quantity;
              if (item.available === false || (typeof item.inventory === 'number' && next > item.inventory)) {
                blocked = true;
                return;
              }
              if (line) updates[line.key] = (line.quantity || 0) + item.quantity;
              else toAdd.push({ id: item.id, quantity: item.quantity });
            });
            if (blocked) return;
            var hasUpdates = Object.keys(updates).length > 0;
            var chain = Promise.resolve();
            if (toAdd.length) chain = chain.then(function () { return self._cartRequest('add', { items: toAdd }); });
            if (hasUpdates) chain = chain.then(function () { return self._cartRequest('update', { updates: updates }); });
            return chain.then(function () {
              if (!toAdd.length && hasUpdates) window.dispatchEvent(new CustomEvent('cart-open'));
            });
          })
          .finally(function () {
            self._adding = false;
            self.render();
          });
      }
    }

    customElements.define('wa-routine-stepper', WARoutineStepper);
  })();
